/**
 * Info badge with light blue background and dark blue text.
 *
 * Used in search result rows to display metric values
 * like GPR, GPV, and Team Style Fit.
 * @module components/shared/search-modal/InfoBadge/InfoBadgeView
 */

import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";

/**
 * Props for InfoBadgeView
 */
interface InfoBadgeViewProps {
  /** Badge text content (e.g. "GPR: 76") */
  readonly label: string;
}

/**
 * Single info badge with light blue background and dark blue text.
 * @param props - Badge props
 * @param props.label - Badge text content
 */
const InfoBadgeView = ({ label }: InfoBadgeViewProps) => (
  <Box className="rounded-none bg-status-info-surface px-2 py-1">
    <Text
      variant="caption"
      className="whitespace-nowrap text-status-info-strong"
    >
      {label}
    </Text>
  </Box>
);

InfoBadgeView.displayName = "InfoBadgeView";

export default memo(InfoBadgeView);
